import { ReactNode, useContext } from "react";
import { ThemeObject } from "../../ThemeObjects";
import { StyledUniversalDiv } from "../Universal";
import { accordionContext } from "./accordionContext";
import styled from "styled-components";
import { AccordionVariant } from "./AccordionsTheme";
import { cn } from "@/util";

const AccordionItemStyledComponent = styled(StyledUniversalDiv)<{
    variant: AccordionVariant;
}>`
    margin-bottom: ${({ variant }) => (variant === "detached" ? "12px" : "0")};

`;

export function StyledAccordionItem({
    children,
    theme,
    contentBlockId,
    title
}: {
    children?: ReactNode;
    theme: Partial<ThemeObject>;
    isDisabled: boolean;
    contentBlockId: string;
    title?:string
}) {
    const accordionContextInternal = useContext(accordionContext);
    const variant = accordionContextInternal.variant;

    // Import-mode short-circuit: source design's scoped CSS controls
    // appearance (margin, border, background). Skip the SC wrapper that
    // would add SimBuilder's detached-variant margin. Gated on
    // imported_design_id, NOT tailwindClasses (non-import items carry it too).
    if (theme?.imported_design_id) {
        return (
            <div
                className={cn(theme.tailwindClasses)}
                data-content-block-id={contentBlockId}
                data-content-block-type={title || "Accordion Item"}
            >
                {children}
            </div>
        );
    }

    return (
        <AccordionItemStyledComponent
            px={theme.px as number}
            py={theme.py as number}
            data-content-block-id={contentBlockId}
            data-content-block-type={title || "Accordion Item"}
            variant={variant}
            className={cn(theme?.tailwindClasses)}
        >
            {children}
        </AccordionItemStyledComponent>
    );
}

export const defaultAccordionItemTheme: Partial<ThemeObject> = {
    py: 0,
    px: 0,
    my: 0,
    mx: 0,
    background: "rgba(0,0,0,0)",
};
